import {
    SET_LISTINGS,
    LOADING_LISTINGS,
    FAILED_LISTINGS
} from '../action-types';
import {TEMPLATE_ID_HEADER} from '../../utils/constants';
import {buildSerpUrl} from '../../utils/urls';
import {isUnrefined} from '../../utils/listings';
import {fetchListingAdditionalContent} from '../listings-additional-content';
import {getValue, TESTS} from '../../utils/abacus';

export const setListings = (listings, lastCardUrl, cachedListings) => {
    return {
        type: SET_LISTINGS,
        ...listings,
        lastCardUrl,
        cachedListings
    };
};

export const loadingListings = (segmentKey, timeoutMs) => {
    return {type: LOADING_LISTINGS, segmentKey, timeoutMs};
};

export const failedListings = () => {
    return {type: FAILED_LISTINGS};
};

export const getLastCardSEOUrl = ({
    adultsCount,
    arrival,
    basePath,
    childrenCount,
    departure,
    keywords,
    name,
    segmentKey,
    serpUrlDomain: host,
    serpUrlFilters
}) => {
    const filterUrl = serpUrlFilters[segmentKey] || {};

    const filter = [];
    const filt = filterUrl.filter;
    if (filt) {
        filter.push(`filter:${filt}`);
    }

    let datedParam = {};
    if (arrival && departure) {
        datedParam = {arrival, departure};
    }

    const params = {
        ...filterUrl,
        filter,
        q: keywords,
        ...datedParam,
        adultsCount: adultsCount || null,
        childrenCount: childrenCount || null
    };

    return buildSerpUrl({
        basePath,
        host,
        params,
        name,
        searchRoot: true,
        useHAStyle: true
    });
};

export const fetchListings = ({dispatch, getState, segmentKey, query = {}, apiPath}) => {
    const {
        abacus,
        config: {
            site: {basePath, name},
            template,
            url: {basePathPrefix}
        },
        destination: {
            segmentFilters: {timeoutMs},
            serpUrlFilters,
            cachedListings = {}
        },
        search: {
            serpUrlDomain,
            keywords,
            arrivalDate: arrival,
            departureDate: departure,
            adults: adultsCount,
            children: childrenCount
        }
    } = getState();

    const lastCardUrl = getLastCardSEOUrl({
        basePath,
        serpUrlFilters,
        segmentKey,
        keywords,
        serpUrlDomain,
        name,
        arrival,
        departure,
        adultsCount,
        childrenCount
    });

    if (cachedListings[segmentKey]) {
        dispatch(setListings(cachedListings[segmentKey], lastCardUrl, cachedListings));
        return null;
    }

    dispatch(loadingListings(segmentKey, timeoutMs));

    if (!isUnrefined(segmentKey)) {
        query.refinementKey = segmentKey;
    }

    const requestUrl = `${basePathPrefix}${apiPath}?${new URLSearchParams(query)}`;

    const getListings = fetch(requestUrl, {
        headers: {
            [TEMPLATE_ID_HEADER]: template
        }
    })
        .then((res) => {
            if (!res.ok) {
                throw new Error('Failed loading listings');
            }
            return res.json();
        })
        .then((listings) => {
            listings = query.lbsIds ? listings[query.lbsIds] : listings;
            if (listings && listings.inventoryCount > 0) {
                dispatch(setListings(listings, lastCardUrl, {...cachedListings, [segmentKey]: listings}));

                if (getValue(abacus, TESTS.OPTIMIZED_PROPERTY_CARD_CONTENT) === 1) {
                    dispatch(fetchListingAdditionalContent(listings, segmentKey));
                }
            } else {
                throw new Error('No listings');
            }
        });

    const timeout = new Promise((resolve, reject) => {
        const wait = setTimeout(() => {
            clearTimeout(wait);
            reject(`Timed out in ${timeoutMs} ms.`);
        }, timeoutMs);
    });

    return Promise.race([getListings, timeout])
        .catch(() => dispatch(failedListings()));
};

